import React, { useState, useEffect } from "react";
import Loader from "../../Components/Common/Loader";
import { Col, Row, Card, CardHeader, CardBody, Button, Dropdown, DropdownItem, DropdownMenu, ButtonGroup, Input, Label, DropdownToggle, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { postDataAPI } from "../../helpers/phpbackend_helper";
import {
    getLocalStorageData, displayDateV1, convertDateFormate, getDateByName, getPercentageWithAlertV1,
    currencyFormatWithoutDecimalV1
} from "../../helpers/api_helper";
import ReactApexChart from "react-apexcharts";
import "../../assets/scss/config/default/WeeklyCalendar.scss";

const data = {
    January: [
        { week: "W1", capture: 78, occupancy: 68, ratio: 85 },
        { week: "W2", capture: 82, occupancy: 72, ratio: 88 },
        { week: "W3", capture: 75, occupancy: 65, ratio: 82 },
        { week: "W4", capture: 88, occupancy: 75, ratio: 91 },
        { week: "W5", capture: 91, occupancy: 78, ratio: 94 },
    ],
    February: [
        { week: "W1", capture: 85, occupancy: 73, ratio: 89 },
        { week: "W2", capture: 79, occupancy: 69, ratio: 84 },
        { week: "W3", capture: 92, occupancy: 79, ratio: 98 },
        { week: "W4", capture: 87, occupancy: 74, ratio: 90 },
    ],
    March: [
        { week: "W1", capture: 83, occupancy: 71, ratio: 87 },
        { week: "W2", capture: 76, occupancy: 66, ratio: 81 },
        { week: "W3", capture: 89, occupancy: 76, ratio: 92 },
        { week: "W4", capture: 94, occupancy: 80, ratio: 97 },
        { week: "W5", capture: 81, occupancy: 70, ratio: 85 },
    ],
};

// const getHeatmapClass = (value) => {
//     if (value >= 90) return "heat-green";
//     if (value >= 80) return "heat-yellow";
//     if (value >= 70) return "heat-orange";
//     return "heat-red";
// };
// const getHeatmapClassAvg = (value) => {
//     if (value >= 60) return "heat-green";
//     if (value >= 40) return "heat-yellow";
//     if (value >= 30) return "heat-orange";
//     return "heat-red";
// };

const WeeklyCalendar = ({ weeklyReport, loading, currency }) => {
    const capitalizeFirstLetter = (str) => {
        if (!str) return "";
        return str.charAt(0).toUpperCase() + str.slice(1);
    }


    const allData = Object.values(weeklyReport).flatMap(weeks =>
        Object.values(weeks).map(dataArr => dataArr[0])
    );

    const captureValues = allData.map(d => d[0]).filter(v => v !== null && v !== 0 && !isNaN(v));
    const occupancyValues = allData.map(d => d[1]).filter(v => v !== null && v !== 0 && !isNaN(v));
    const avgCheckValues = allData.map(d => d[2]).filter(v => v !== null && v !== 0 && !isNaN(v));
    const buildColorScale = (values) => {
        const min = Math.min(...values);
        const max = Math.max(...values);
        const range = max - min;
        const steps = 5;
        const stepSize = range / steps;

        const colors = [
            '#F8696B',  // Very Low (Red)
            '#FA8A72',  // Low
            '#FECB7E',  // Medium
            '#8AC97D',  // High
            '#63BE7B'   // Very High (Green)
        ];

        return (val) => {
            if (val <= min) return colors[0];
            if (val >= max) return colors[colors.length - 1];
            const index = Math.floor((val - min) / stepSize);
            return colors[Math.min(index, colors.length - 1)];
        };
    };

    const getHeatmapClassCapture = buildColorScale(captureValues);
    const getHeatmapClassOccupancy = buildColorScale(occupancyValues);
    const getHeatmapClassAvg = buildColorScale(avgCheckValues);

    return (
        <Row>
            <Card>
                <CardHeader className="ps-0 border-0 align-items-center">
                    <div className="d-flex align-items-start">
                        <div className={`icon-box rounded bg-danger text-white`}>
                            <i className="ri-calendar-2-fill"></i>
                        </div>
                        <div className="ps-2">
                            <h4 className="card-title mb-0 flex-grow-1">Weekly Capture Ratio Calendar</h4>
                            <p>Year-over-year weekly performance showing capture ratios, occupancy levels, and average check amounts</p>
                        </div>
                    </div>
                </CardHeader>
                <CardBody className="p-0">
                    {loading && <Loader />}
                    <div className={loading ? "opacity-0" : ""}>
                        <table className="heatmap-table">
                            <thead>
                                <tr>
                                    <th>Month</th>
                                    <th className="text-center">Week</th>
                                    <th className="text-center">Capture</th>
                                    <th className="text-center">Occupancy</th>
                                    <th className="text-center">Avg Check</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Object.entries(weeklyReport).map(([month, weeks]) => {
                                    const weekEntries = Object.entries(weeks);
                                    return weekEntries.map(([week, dataArr], index) => {
                                        const [capture, occupancy, avgCheck] = dataArr[0];

                                        return (
                                            <tr key={`${month}-${week}`}>
                                                {index === 0 && (
                                                    <td rowSpan={weekEntries.length} className="month-cell" style={{ verticalAlign: "top" }}>
                                                        {month}
                                                    </td>
                                                )}
                                                <td className="text-center">{capitalizeFirstLetter(week)}</td>
                                                <td className="text-center">
                                                    <span className="heat-box" style={{ backgroundColor: getHeatmapClassCapture(capture) }}>
                                                        {(capture).toFixed(2)}%
                                                    </span>
                                                </td>
                                                <td className="text-center">
                                                    <span className="heat-box" style={{ backgroundColor: getHeatmapClassOccupancy(occupancy) }}>
                                                        {occupancy.toFixed(2)}%
                                                    </span>
                                                </td>
                                                <td className="text-center">
                                                    {currency + avgCheck.toFixed(2)}
                                                </td>
                                            </tr>
                                        );
                                    });
                                })}
                            </tbody>
                        </table>

                    </div>
                </CardBody>
            </Card>
        </Row>
    );
};

export default WeeklyCalendar;
